module.exports = __webpack_public_path__ + "static/media/goblin_shield.bfe9a268.png";